import {
    Box,
    Chip,
    Grid,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import stringUtils from "../../utils/stringUtils";
import ModalPoliticas from "../ModalPoliticas";

const TableEmpresaPoliticas = (props) => {
    const [abrirPoliticaModal, setAbrirModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState(0);
    const [id, setId] = useState(0);
    const [politica, setPolitica] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(async () => {
        setRows(props.rows);
    }, [props.id]);
    useEffect(async () => {
        setRows(props.rows);
    }, [props.rows]);
    useEffect(async () => {
        setTotal(props.total);
    }, [props.total]);
    useEffect(async () => {
        setPagina(props.pagina);
    }, [props.pagina]);

    const padding = props.padding ? props.padding : 12;

    const emptyRows = 10 - Math.min(10, rows.length);

    const fecharPoliticaModal = (e) => {
        setAbrirModal(false);
    };

    return (
        <Paper>
            <Modal
                open={abrirPoliticaModal}
                onClose={fecharPoliticaModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Grid>
                    <ModalPoliticas
                        fecharModal={fecharPoliticaModal}
                        loading={loading}
                        empresaId={props.empresaId}
                        politica={politica}
                        empresa={props.empresa}
                        buscarPoliticas={props.buscarPoliticas}
                    />
                </Grid>
            </Modal>
            <TableContainer>
                <Table aria-label="sticky table" sx={{ minHeight: "38rem" }}>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>#Id Empresa</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Razão Social</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>CNPJ</b>
                                </Box>
                            </TableCell> */}
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>#Id Modelo</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Nome</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Valor</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Status</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Ações</b>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                >
                                    {/* <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Chip size="small" label={row.empresa.id} />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>{row.empresa.razao_social}</Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>{row.empresa.cnpj}</Box>
                                    </TableCell> */}
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Chip size="small" label={row.modelo.id} />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>{row.modelo.nome_consulta}</Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {stringUtils.formatBRL(row.valor)}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {row.modelo.ativo ? (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#6CA76B",
                                                        color: "#FFF",
                                                    }}
                                                    label="Ativo"
                                                />
                                            ) : (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#F44336",
                                                        color: "#FFF",
                                                    }}
                                                    label="Inativo"
                                                />
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                // component={Link}
                                                onClick={(e) => {
                                                    setPolitica(row);
                                                    setAbrirModal(true);
                                                }}
                                                aria-label="visualizar"
                                                size="small"
                                                height={11}
                                                width={11}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={7} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={parseInt(total)}
                rowsPerPage={parseInt(total)}
                page={parseInt(pagina)}
                onChangePage={props.handleChangePage}
            />
            {/* MODAL */}
        </Paper>
    );
};

export default TableEmpresaPoliticas;
